import moment from "moment";

export const locationHasTimezoneDiff = locationCode => {
  // Londres, Lisboa, Oporto
  return /(LON|LIS|OPO)/.test(locationCode);
}
export const getFlightDurationText = (flight, type, destinationCode) => {
  let timezoneHoursDiff = 0;
  if (locationHasTimezoneDiff(destinationCode)) {
    timezoneHoursDiff = type === 'journey' ? 1 : -1;
  }
  const departure = moment(flight[`${type}FlightDepartureTime`]);
  const arrival = moment(flight[`${type}FlightArrivalTime`]);
  const hours = arrival.add(timezoneHoursDiff, 'hours').diff(departure, "hours");
  departure.add(hours, "hours");
  const minutes = arrival.diff(departure, "minutes");
  const hoursText = hours ? `${hours}h` : "";
  const minutesText = minutes ? `${minutes}m` : "";
  if (hours && minutes) {
    return `${hoursText}, ${minutesText}`;
  }
  return hours ? hoursText : minutesText;
};

export const round = number => Number(parseFloat(number).toFixed(2));

export const minutesToHoursMinutes = (totalMinutes) => {
  var hours = Math.floor(totalMinutes / 60);
  var minutes = totalMinutes % 60;
  return `${hours}h ${minutes}m`;
}
